import { useRef } from "react";
import { useEffect } from "react";
import "../../../assets/style/featuresStyle/button.scss";
import { useState } from "react";
import { IconAddIMG } from "../../../assets/icon";
const UploadIcon = ({ setImage, width, height, url, accept }) => {
  const [isPreview, setIsPreview] = useState(url ? true : false);
  const [previewIMG, setPreviewIMG] = useState();
  const handlePreviewIMG = (e) => {
    const file = e.target.files[0];
    file.preview = URL.createObjectURL(file);
    setPreviewIMG(file);
    setImage(file);
  };
  const inputRef = useRef();
  useEffect(() => {
    if (previewIMG) {
      setIsPreview(false);
    }
  }, [previewIMG]);
  useEffect(() => {
    if (previewIMG) {
      setIsPreview(false);
    }
  }, [previewIMG]);
  useEffect(() => {
    return () => {
      previewIMG && URL.revokeObjectURL(previewIMG.preview);
    };
  }, [previewIMG]);
  const handleChooseImage = (e) => {
    inputRef.current.click();
  };
  const style = {
    width,
    height,
  };
  useEffect(() => {
    if (url) {
      setIsPreview(true);
    }
  }, [url]);
  return (
    <div className="btnChooseIcon" style={style}>
      <input
        type="file"
        ref={inputRef}
        accept="image/svg+xml"
        style={{ display: "none" }}
        onChange={handlePreviewIMG}
      />
      {previewIMG ? (
        <div className="haveIMG">
          <span className="iconChange" onClick={handleChooseImage}>
            <img
              src={previewIMG.preview}
              width={28}
              height={50}
              alt="errr"
            ></img>
          </span>
        </div>
      ) : !previewIMG && !isPreview ? (
        <div className="noIMG">
          <div className="upload" onClick={handleChooseImage}>
            <IconAddIMG width={28} height={50} />
          </div>
        </div>
      ) : (
        <div className="haveIMG">
          <span className="iconChange" onClick={handleChooseImage}>
            <img
              width={28}
              height={50}
              src={`${window.SERVER_URL}/${url}`}
              alt="fail"
            ></img>
          </span>
        </div>
      )}
    </div>
  );
};
export default UploadIcon;
